import { UIMFullscreenTabView } from './UIMFullscreenTabView.ts';
import { UIMRoomEditPageController } from './UIMRoomEditPageController.ts';
import { UIMRoomSettingsController } from './UIMRoomSettingsController.ts';
var SetupPageTabs = /*#__PURE__*/ function(SetupPageTabs) {
    SetupPageTabs[SetupPageTabs["SelectMode"] = 0] = "SelectMode";
    SetupPageTabs[SetupPageTabs["SelectMap"] = 1] = "SelectMap";
    SetupPageTabs[SetupPageTabs["SelectSettings"] = 2] = "SelectSettings";
    return SetupPageTabs;
}(SetupPageTabs || {});
export class UIMRoomSetupPageController extends UIMRoomEditPageController {
    initializeRoomPageView() {
        const title = {
            key: 'strings:roomPage.notifications.edit'
        };
        const tabProperties = [
            {
                title: {
                    key: 'strings:game.settings.gameInfoTab.gameMode.titleAbbreviated'
                },
                isActive: true,
                containerClass: 'm-room-settings-cards-container-grid room_center_options',
                id: 0
            },
            {
                title: {
                    key: 'strings:game.settings.gameInfoTab.map.title'
                },
                isActive: false,
                containerClass: 'm-room-settings-cards-container-grid room_center_options',
                id: 1
            },
            {
                title: {
                    key: 'strings:game.gearIcon.settings'
                },
                isActive: false,
                containerClass: 'm-room-settings-cards-container',
                id: 2
            }
        ];
        const buttonText = {
            key: 'strings:homePage.matchmakingPopup.createRoom.title'
        };
        this.roomPageView = new UIMFullscreenTabView(title, tabProperties, buttonText, (tabIdx)=>{
            if (tabIdx != 2) return;
            this.roomSettingsController.update(this.roomState);
        });
    }
    async initializeControllers() {
        await super.initializeControllers();
        this.roomSettingsController = new UIMRoomSettingsController(this.roomPageView.getContainerWithTabIdx(2), this.roomState, (idx, playSound)=>this.roomPageView.updateActiveTabToIndex(idx, playSound));
    }
    update(roomState) {
        super.update(roomState);
        this.roomSettingsController.update(roomState);
    }
    showRoomPage() {
        super.showRoomPage();
        this.roomSettingsController.setPrivateRoomStateSync(true);
    }
}
